export type AllotmentDocKind = 'share_application' | 'directors_resolution' | 'members_resolution' | 'unknown';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export function classifyAllotmentDoc(input: {
  docCode?: unknown;
  templateName?: unknown;
}): AllotmentDocKind {
  const code = trim(input.docCode).toUpperCase();
  if (code === 'PRS011') return 'share_application';
  if (code === 'PRS013') return 'directors_resolution';
  if (code === 'PRS012') return 'members_resolution';

  const name = trim(input.templateName).toLowerCase();
  if (!name) return 'unknown';
  if (/share\s*application/.test(name)) return 'share_application';
  if (/director/.test(name) && /allotment/.test(name)) return 'directors_resolution';
  if (/(member|shareholder)/.test(name) && /allotment/.test(name)) return 'members_resolution';
  return 'unknown';
}

